import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Col,
  CustomInput,
  Form,
  FormGroup,
  FormText,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from 'reactstrap';
import {
  BtnOutlineGreen,
  BtnOutlineRed,
  ContFilterCheckbox,
} from '../../../styled-components';
import DateInput from '../../../commons/DateInput';
import { useAuth } from '../../../commons/Auth';
import { useAlert } from 'react-alert';

const INITAL_FILE_FORM_VALUES = {
  file: '',
};

function AddFileButton({ uploadFile, documentTypes }) {
  const [t] = useTranslation('FILES');
  const alert = useAlert();
  const [{ newIsAdmin } = {}] = useAuth();
  const [addNewFileModal, setAddNewFileModal] = useState(false);
  const [formValues, setFormValues] = useState(INITAL_FILE_FORM_VALUES);
  const [errors, setErrors] = useState({
    file: false,
  });
  const [firstTry, setFirtsTry] = useState(true);

  useEffect(() => {}, [errors]);

  const toggleAddNewFileModal = () => {
    setFormValues(INITAL_FILE_FORM_VALUES);
    setAddNewFileModal(!addNewFileModal);
    setFirtsTry(true);
  };

  function handleFileChange() {
    const file = formValues.file;

    const fileSize = (file.size / 1024 ** 2).toFixed(2);

    if (fileSize > 20) {
      alert.info('File troppo grande. Max 20Mb');
    } else {
      const data = new FormData();
      data.append('file', file);

      setFirtsTry(false);
      errors.file = false;

      if (file === '') errors.file = true;

      const arrayErrors = Object.values(errors);
      if (!arrayErrors.includes(true)) {
        uploadFile(data, toggleAddNewFileModal);
      }
    }
  }

  return (
    <React.Fragment>
      <Button
        target="_blank"
        color="primary"
        style={{ marginTop: 0 }}
        onClick={(event) => {
          event.stopPropagation();
          toggleAddNewFileModal();
        }}
      >
        Aggiungi
      </Button>

      <Modal
        isOpen={addNewFileModal}
        toggle={toggleAddNewFileModal}
        className="new-file-modal"
      >
        <ModalHeader toggle={toggleAddNewFileModal}>
          {t('FILES:ADD')}
        </ModalHeader>
        <Form
          onSubmit={(e) => {
            e.preventDefault();
            handleFileChange();
          }}
        >
          <ModalBody>
            <Row>
              <Col sm="12">
                <FormGroup>
                  <Label for="selectFile">
                    {t('FILES:CHOOSE_FILE')}
                    &nbsp;({t('FILES:MAX_UPLOAD_FILE_SIZE')})
                  </Label>
                  <CustomInput
                    type="file"
                    id="fileCommercialContract"
                    name="fileCommercialContract"
                    onChange={(event) =>
                      setFormValues({
                        ...formValues,
                        file: event.target.files[0],
                      })
                    }
                  />
                  {formValues.file === '' && !firstTry && (
                    <FormText className="error-message">
                      {t('FILE_ERROR')}
                    </FormText>
                  )}
                </FormGroup>
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <BtnOutlineRed
              type="button"
              className="uppercase"
              onClick={toggleAddNewFileModal}
            >
              {t('COMMON:CANCEL')}
            </BtnOutlineRed>
            <BtnOutlineGreen type="submit" className="uppercase">
              {t('COMMON:CONFIRM')}
            </BtnOutlineGreen>
          </ModalFooter>
        </Form>
      </Modal>
    </React.Fragment>
  );
}

export default AddFileButton;
